import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const FAQS = [
  {
    pregunta: "¿Cuánto cuesta cotizar?",
    respuesta: "Nada. La cotización y la asesoría no tienen costo.",
  },
  {
    pregunta: "¿Por qué contratar con un agente y no directo con la aseguradora?",
    respuesta:
      "Porque comparamos entre varias compañías y te representamos a ti, no a la aseguradora, cuando hay un siniestro.",
  },
  {
    pregunta: "¿Qué hago si tengo un siniestro?",
    respuesta:
      "Llámanos o escríbenos por WhatsApp. Te guiamos paso a paso y damos seguimiento hasta que se resuelva.",
  },
  {
    pregunta: "¿Puedo cambiar mi póliza actual con ustedes?",
    respuesta: "Sí. Revisamos tu póliza vigente y te decimos si hay una opción mejor.",
  },
];

export const Faq = () => (
  <section id="preguntas" data-testid="faq-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-3xl px-5 sm:px-8">
      <Reveal className="text-center">
        <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
          Preguntas frecuentes
        </p>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0C5F8A] sm:text-3xl lg:text-4xl">
          Resolvemos tus dudas
        </h2>
      </Reveal>

      <Reveal delay={0.12} className="mt-12">
        <Accordion type="single" collapsible className="space-y-4">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={faq.pregunta}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-[#1BA8E0]/15 bg-[#E8F6FD]/50 px-6 shadow-[0_10px_30px_-5px_rgba(12,95,138,0.06)] transition-colors data-[state=open]:bg-white data-[state=open]:shadow-[0_18px_40px_-12px_rgba(12,95,138,0.18)]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-5 text-left font-display text-base font-semibold text-[#0C5F8A] hover:text-[#1BA8E0] hover:no-underline sm:text-lg"
              >
                {faq.pregunta}
              </AccordionTrigger>
              <AccordionContent data-testid={`faq-content-${i}`} className="pb-6 text-sm leading-relaxed text-[#2E3338]/80 sm:text-base">
                {faq.respuesta}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
